<template>
  <div class=spiel-container>
    <select v-model="spiel" class="spiel-auswahl">
      <option>Shisen</option><option>Mahjongg</option><option>Pasienta</option>
    </select>
    <Shisen v-if="spiel==='Shisen'" @change-groesse="onChangeGroesse" @change-thema="onChangeThema" />
    <Mahjongg v-if="spiel==='Mahjongg'" @change-groesse="onChangeGroesse" @change-thema="onChangeThema"/>
    <Pasienta v-if="spiel==='Pasienta'" @change-groesse="onChangeGroesse" />
  </div>
</template>

<script setup>
import Shisen from '@/components/Shisen.vue';
import Mahjongg from '@/components/Mahjongg.vue';
import Pasienta from '@/components/Pasienta.vue';
import { ref, provide } from 'vue';
let spiel = ref('Shisen');

let wert = localStorage.getItem('groesse');
if (!wert) {
  wert = '7.5';
  localStorage.setItem('groesse', wert);
}
const groesse = ref( (isNaN(wert) ? 8 : parseFloat(wert)) );
provide('groesse', groesse);
wert = localStorage.getItem('thema') || '0';
const thema = ref( (isNaN(wert) ? 0 : parseFloat(wert)) );
provide('thema', thema);

function onChangeGroesse(faktor) {
  faktor = groesse.value + faktor;
  if (!isNaN(faktor)) {
    groesse.value = faktor;
    localStorage.setItem('groesse', faktor);
  }
}
function onChangeThema(faktor) {
  if (!isNaN(faktor)) {
    thema.value = faktor;
    localStorage.setItem('thema', faktor);
  }
}
</script>


<style>
.spiel-container {
  font-family: 'Noto Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fff;
  font-size: 15px;
  margin: 1rem 0 0 2rem;
}

.spiel-container * {
  font-family: inherit;
  font-size: inherit;
}
.spiel-auswahl {
  position: absolute;
  left: 2.5rem;
  z-index: 300;
}
select {
  position: relative;
  background-color: #fff;
  border: none;
  height: 1.75rem;
  box-shadow: 1px 1px 1px #bbb;
}
@keyframes zeigeklick {
  0% {
    background-color: rgba(212, 212, 212);
  }  
  20% {
    background-color: rgba(212, 212, 212, 0.9);
  }
  40% {
    background-color: rgba(212, 212, 212, 0.8);
  }
  60% {
    background-color: rgba(212, 212, 212, 0.6);
  }
  80% {
    background-color: rgba(212, 212, 212, 0.3);
  }
  100% {
    background-color: transparent;
  }
}
.klick_reaktion  {
  animation: zeigeklick 0.2s;
}

.bild-karte {
  border: 1px solid #333;
  width: 100%;
  margin: 2px;
  touch-action: none;
  position: relative;
  z-index: 10;
}
.selected.bild-karte {
  border: 3px solid #84c3f1;
  margin: 0;
}

.b-container {
  position: relative;
  border-radius: 50%;
  padding: 10px;
  top: -5px;
}
.stuffen {
  position: relative;
  padding-left: 20px;
}
.felder {
  position: absolute;
}
.tool {
  margin: 1rem 0 1rem 7rem;
  display: flex;
  position: relative;
  z-index: 300;
}
.tool2 {
  margin: 1rem;
  display: flex;
  position: relative;
  z-index: 300;
}
.tool button {
  border: none;
  padding: 0;
  background-color: transparent;
}
.tool2 button {
  border: none;
  padding: 0;
  background-color: transparent;
  /* margin-right: 4px; */
}
.tool button i {
  color: rgb(74, 74, 252);
}
.groesse {
  padding-left: 25px;
}
.spiel-data {
  width: 100%;
  font-size: 13px !important;
  height: 24px;
}
.zeige-anzahl {
  float: right;
  margin: 4px 2px;
}


.container {
	position: relative;
	background-color: #51a145;
	min-height: 500px;
}
.feld-cont {
	position: relative;
}
.karten-cont {
	display: inline-block;
  margin: 15px 4px 0 4px;
  touch-action: none;
}
.leer-cont {
	position: absolute;
	display: inline-block;
  margin: 15px 4px 0 4px;
	top: 0;
  touch-action: none;
}

.stein {
  position: absolute;
  top: 0px;
  height: 100%;
  touch-action: none;
}
.stein img {
  height: 100%;
}
.active {
  background-color: #FFFFE7
}
.inactive {
  background-color: rgb(208, 240, 235)
}


.shisen-felder {
  position: relative;
}
</style>

